import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Card,
  CardBody,
  CardHeader,
  Chip,
  Typography,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { httpForPScreen } from "../../../services/http-common";
import { toast } from "react-toastify";
import { formatFullTime } from "../../../utils/dateFormat";
import { setSessionExpired, useMainController } from "../../../context";
let CURRENT_TIME = new Date();

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const PsiloScreen = () => {
  const [dispatch] = useMainController();
  const { selectedSeekerDetails } = useSelector((state) => state.dataFlow);
  const [results, setResults] = useState(null);
  const [selectedResult, setSelectedResult] = useState(null);

  const getSeekersList = useMutation(
    () => {
      return httpForPScreen.get(
        `psiloscreen/intakeform/find-reports-by-seeker?id=${selectedSeekerDetails?.attendees?.seekerId}`,
        null,
        setSessionExpired,
        dispatch
      );
    },
    {
      onSuccess: ({ data }) => {
        setResults(data.records);
        setSelectedResult(data.records[0]);
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );

  useEffect(() => {
    getSeekersList.mutate();
  }, []);

  return (
    <>
      <div>
        <Card variant="gradient" className="w-full p-8">
          <CardHeader
            floated={false}
            shadow={false}
            color="transparent"
            className="m-0 rounded-none border-b border-white/10 pb-8 text-center"
          >
            <Typography
              variant="small"
              className="font-bold normal-case text-[#000080] "
            >
              PsiloScreen Results
            </Typography>
            <Typography
              variant="h1"
              className="mt-1 flex justify-center gap-1 text-2xl font-normal"
            >
              {selectedSeekerDetails?.attendees?.user?.firstName}
            </Typography>
          </CardHeader>
          <CardBody className="p-0">
            {results &&
              results.map((result) => (
                <Accordion
                  key={result.id}
                  open={selectedResult?.id === result.id}
                  icon={<Icon id={1} open={selectedResult?.id === result.id} />}
                >
                  <AccordionHeader onClick={() => setSelectedResult(result)}>
                    <div className="flex justify-start items-center gap-2">
                      <Typography
                        variant="lead"
                        color="black"
                        className="font-normal leading-none opacity-70"
                      >
                        PsiloScore:{" "}
                        {JSON.parse(result.report)?.acuityScore?.AcuityLevel}
                      </Typography>
                      <Chip
                        variant="outlined"
                        className="py-0.5 text-center w-auto px-2 text-[11px] font-medium"
                        size="sm"
                        color="purple"
                        value={formatFullTime(result.updated_at)}
                      />
                    </div>
                  </AccordionHeader>
                  <AccordionBody>
                    <table className="w-full min-w-max table-auto text-left">
                      <thead>
                        <tr>
                          {["Field", "Information"].map((head) => (
                            <th
                              key={head}
                              className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 "
                            >
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal leading-none opacity-70"
                              >
                                {head}
                              </Typography>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              Acuity Score
                            </Typography>
                          </td>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {
                                JSON.parse(result.report)?.acuityScore
                                  ?.AcuityScore
                              }
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              Acuity Level
                            </Typography>
                          </td>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {
                                JSON.parse(result.report)?.acuityScore
                                  ?.AcuityLevel
                              }
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              Age
                            </Typography>
                          </td>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {CURRENT_TIME.getFullYear() -
                                JSON.parse(result.report)?.prompts
                                  ?.birthYear}{" "}
                              years old
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              Current Medications
                            </Typography>
                          </td>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {
                                JSON.parse(result.report)?.prompts
                                  ?.currentMedication
                              }
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              Past and Current Medical Conditions
                            </Typography>
                          </td>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {
                                JSON.parse(result.report)?.prompts
                                  ?.pastAndCurrentMedicalConditions
                              }
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              Known Allergies
                            </Typography>
                          </td>
                          <td className={"p-4 border-b border-blue-gray-50"}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {JSON.parse(
                                result.report
                              )?.prompts?.knownAllergies.map((allergy, idx) => (
                                <span key={idx}>
                                  {allergy.allergy}
                                  {idx + 1 ===
                                  JSON.parse(result.report)?.prompts
                                    ?.knownAllergies.length
                                    ? ""
                                    : ", "}
                                </span>
                              ))}
                            </Typography>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </AccordionBody>
                </Accordion>
              ))}
          </CardBody>
        </Card>
        <Card className="my-5">
          <CardBody>
            <div className="mb-4 flex items-center justify-between">
              <Typography variant="h5" color="blue-gray">
                Reminders & Recent Activities
              </Typography>
            </div>
          </CardBody>
        </Card>
      </div>
      {/* <div className="bg-white">
        <Card>
          <CardHeader color="white" className="p-4">
            <Typography variant="h4" color="blue-gray">
              PsiloScreen Results for{" "}
              {selectedSeekerDetails?.attendees?.user?.firstName}
            </Typography>
          </CardHeader>
          <CardBody className="max-h-96 overflow-y-auto p-0">
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              {results &&
                results.map((result) => (
                  <Accordion
                    key={result.id}
                    open={selectedResult?.id === result.id}
                    className="border-b"
                  >
                    <AccordionHeader
                      onClick={() => setSelectedResult(result)}
                      className="flex justify-start items-center gap-2"
                    >
                      PsiloScore:{" "}
                      {JSON.parse(result.report)?.acuityScore?.AcuityLevel}
                      <Chip
                        variant="outlined"
                        className="py-0.5 text-center w-auto px-2 text-[11px] font-medium"
                        size="sm"
                        color="purple"
                        value={formatFullTime(result.updated_at)}
                      />
                    </AccordionHeader>
                    <AccordionBody>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell className="font-bold">Field</TableCell>
                            <TableCell className="font-bold">
                              Information
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>Acuity Score</TableCell>
                            <TableCell>
                              {
                                JSON.parse(result.report)?.acuityScore
                                  ?.AcuityScore
                              }
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Acuity Level</TableCell>
                            <TableCell>
                              {
                                JSON.parse(result.report)?.acuityScore
                                  ?.AcuityLevel
                              }
                            </TableCell>
                          </TableRow>
                          {JSON.parse(result.report)?.prompts?.birthYear && (
                            <TableRow>
                              <TableCell>Age</TableCell>
                              <TableCell>
                                {CURRENT_TIME.getFullYear() -
                                  JSON.parse(result.report)?.prompts
                                    ?.birthYear}{" "}
                                years old
                              </TableCell>
                            </TableRow>
                          )}
                          <TableRow>
                            <TableCell>Current Medications</TableCell>
                            <TableCell>
                              {
                                JSON.parse(result.report)?.prompts
                                  ?.currentMedication
                              }
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              Past and Current Medical Conditions
                            </TableCell>
                            <TableCell>
                              {
                                JSON.parse(result.report)?.prompts
                                  ?.pastAndCurrentMedicalConditions
                              }
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Known Allergies</TableCell>
                            <TableCell>
                              {JSON.parse(
                                result.report
                              )?.prompts?.knownAllergies.map((allergy, idx) => (
                                <span key={idx}>
                                  {allergy.allergy}
                                  {idx + 1 ===
                                  JSON.parse(result.report)?.prompts
                                    ?.knownAllergies.length
                                    ? ""
                                    : ", "}
                                </span>
                              ))}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </AccordionBody>
                  </Accordion>
                ))}
            </div>
          </CardBody>
        </Card>
      </div> */}
    </>
  );
};

export default PsiloScreen;
